/* eslint-disable */
import React, { Component } from 'react';
import { Select } from 'antd';
import { apiClient } from '../../../api';
import{root} from '../../../config';
import { token, CheckTokenExp } from '../../../config';
import ModalServerError from '../Modal/ModalServerError';

const { Option } = Select;

export default class SelectCampaign extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            list: [],
            select: [],
            accounts: [],
            users: [],
            campaign: [],
            otpconfig: [],
            report_Template: 0,
            modalVisible: false,
        };

        this.getData = this.getData.bind(this);

    }

    componentDidMount() {
        this.getData("",this.state.accounts, this.state.users, this.state.campaign, this.state.report_Template, this.state.otpconfig);
    }


    componentWillReceiveProps(nextProps) {

        if (nextProps.accounts !== this.state.accounts) {
            this.setState({ accounts: nextProps.accounts }, () => {
                this.getData('', this.state.accounts, this.state.users, this.state.campaign, this.state.report_Template, this.state.otpconfig)  });
            
        }

        if (this.state.users !== nextProps.users) {
            this.setState({ users: nextProps.users }, () => {
                this.getData('', this.state.accounts, this.state.users, this.state.campaign, this.state.report_Template, this.state.otpconfig)  });
            
        }


        if (this.state.campaign !== nextProps.campaign) {
            this.setState({ campaign: nextProps.campaign }, () => { 
                this.getData('', this.state.accounts, this.state.users, this.state.campaign, this.state.report_Template, this.state.otpconfig) 
            });
            
        }

        if (this.state.report_Template !== nextProps.report_Template) {
            this.setState({ report_Template: nextProps.report_Template }, () => { 
                this.getData('', this.state.accounts, this.state.users, this.state.campaign, this.state.report_Template, this.state.otpconfig) 
            });
           
        }
        if (this.state.report_Template == 3 )
        {
            if (this.props.otp !== nextProps.otpconfig) {
                this.setState({ otp: nextProps.otpconfig }, () => {
                    this.getData('', this.state.accounts, this.state.users, this.state.campaign, this.state.report_Template, this.state.otpconfig)  });
                
            }
        }

       /*  this.getData("", this.state.accounts, this.state.users, this.state.campaign, this.state.report_Template, this.state.otpconfig)  */
       
    }


    getData(value, accounts, users, campaign, report_Template, otpconfig) {
        if (!CheckTokenExp()) {
            this.state.list.length > 0 ? "" : this.setState({ loading: true });
            var Otpdata = otpconfig ? otpconfig : [];
            let req = JSON.stringify({
                report_type: report_Template,    
                name: value,
                accountid: accounts,
                userid: users,
                campid: campaign,             
                otp_cofig: Otpdata,
            });

            apiClient.post('api/Report/SenderList_createreport', req
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    }
                })
                .then(data => {
                    if (data.status === 200 && data.data) {
                        this.setState({ list: data.data });
                    } else {
                        this.setState({ modalVisible: true });
                        this.setState({ list: [] });
                    }
                    this.setState({ loading: false });
                })
                .catch(error => {
                    this.setState({ modalVisible: true });
                    this.setState({ list: [] });
                    this.setState({ loading: false });
                });
        } else {
            window.location.href = "logout";
        }

    }

    render() {
        const { loading, list, modalVisible } = this.state;
        const { placeholder, mode, disablestatus, select, setStateByProps, by, style, accounts, users, campaign, report_Template, otpconfig } = this.props;
        return (
            <>
                <Select
                    mode={mode == "default" ? "default" : "multiple" }
                    allowClear={mode ? true : false}
                    showSearch
                    disabled={disablestatus == true ? true : false}

                    style={style ? style : null}
                    loading={loading}
                    name="select"
                    onSearch={(value) => { this.getData(value, accounts, users, campaign, report_Template, otpconfig) }}
                    onChange={(value) =>  setStateByProps("sender", value) }
                    value={select}
                    suffixIcon={loading ? "" : <span className="fa fa-angle-down" />}
                    placeholder={placeholder ? placeholder : "Enter new sender name or select from options here."}
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >

                    {by == "id" ?
                        list.map((item, index) =>
                            <Option key={index} value={item.ID}>{item.TEXT}</Option>
                        )
                        :
                        list.map((item, index) =>
                            <Option key={index} value={item.TEXT}>{item.TEXT}</Option>
                        )
                    }
                </Select>
                <ModalServerError modalVisible={modalVisible}/>
            </>
        );
    }
}


